// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__lf9Ui","inner":"Footer_inner__1SEsD","nextIcon":"Footer_nextIcon__2oIhR","innerLeft":"Footer_innerLeft__dTaYw"};